import React from 'react';
import { View } from 'react-native';

import { Text, TextInput } from '../../components';
import { useForm } from '../../../common/utils/hooks';
import { useThemedStyles } from '../../hooks/useThemedStyles';
import { PrimaryButton } from '../../design/components';
import { isMyDayTraining } from '../myDay/myDayTraining';


const CantResolveDialog = ({
	cantResolveTicket,
	ticketListItem,
	closeDialog,
	trainingContext,
	serviceDocketId,
}) => {
	const styles = useThemedStyles(createStyles);
	const { values, onChange } = useForm({ notResolvedComment: '' });
	const isTraining = isMyDayTraining(trainingContext);

	const onSubmit = async () => {
		await cantResolveTicket({
			variables: {
				ticketListItemId: ticketListItem.id,
				notResolvedComment: values.notResolvedComment,
				...(isTraining ? {
					adminTraining: true,
					serviceDocketId,
				} : {}),
			},
		});

		return closeDialog();
	};

	return (
		<View style={styles.dialog}>
			<Text style={styles.fieldLabel}>Comment</Text>
			<TextInput
				multiline={true}
				numberOfLines={4}
				style={styles.commentInput}
				value={values.notResolvedComment}
				onChange={onChange('notResolvedComment')}
			/>
			<PrimaryButton
				label="Mark as not resolved"
				onPress={onSubmit}
			/>
		</View>
	);
};

const createStyles = ({ ui: { colors, type, space } }) => ({
	dialog: {
		gap: space.sm,
	},
	fieldLabel: {
		...type.fieldLabel,
		color: colors.text,
	},
	commentInput: {
		height: 100,
		marginBottom: space.sm,
	},
});

export default CantResolveDialog;
